import React, { memo, useEffect, useState } from 'react';
import styles from './avatar.module.scss';

const Avatar = ({ name, lastname, email, inheritClass, list }) => {

    const [displayNameAbr, setDisplayNameAbr] = useState("");

    useEffect(() => {
        if (name && lastname) {
            setDisplayNameAbr(`${name.charAt(0)}${lastname.charAt(0)}`);
        } else if (name && lastname && !lastname.length) {
            setDisplayNameAbr(`${name.charAt(0)}${name.charAt(1)}`);
        } else if (email) {
            setDisplayNameAbr(`${email.charAt(0)}${email.charAt(1)}`);
        }

    }, [setDisplayNameAbr, name, lastname, email]);

    return (
        <div className={`${inheritClass} ${styles.avatar} ${list && styles.list}`}>
            <span>{displayNameAbr.toUpperCase()}</span>
        </div>
    )
}

export default memo(Avatar);
